import React from "react";
import ShowDateTime from "show/components/ShowDateTime";
import { ShowSidePanel } from "./Show/ShowSidePanel";
import AppointmentPhase from "components/Atoms/AppointmentPhase";

interface ShowForSidePanelProps {
  show: {
    showId: number
    title: string
    status: server.dto.StatusSmall
    dateTime: server.dto.AppointmentDateTime
    promoterName: string
  }
}

export const ShowForSidePanel = (props: ShowForSidePanelProps) => {
  return <ShowSidePanel
    canEdit
    showId={props.show.showId}
    trigger={<div className="side-panel-list-item hoverable flex gap">

      <AppointmentPhase value={props.show.status.appointmentPhase} displayLabel={false} />

      <div className="flex-column gap">
        <div>
          <div className="info-text-medium">{props.show.title}</div>
          <ShowDateTime dateTime={props.show.dateTime} />
        </div>
        <div className="subtitle-text-medium">{props.show.promoterName}</div>
      </div>
    </div>}
  />
};